// WP-C1.8 (SR-2): tags on parties/projects/quotations — a thin wrapper adapting the generic
// entity-tag hooks to TagInput's own controlled value/onChange contract. Mirrors NotesSection's
// own "reusable cross-entity section" shape (SR-4).
import { useEntityTags, useSetEntityTags } from '../lib/entityTags';
import { TagInput } from './TagInput';

export function EntityTagSection({
  entityType,
  entityId,
}: {
  entityType: string;
  entityId: string;
}): React.JSX.Element {
  const { data: tagIds } = useEntityTags(entityType, entityId);
  const setTags = useSetEntityTags(entityType, entityId);

  return (
    <div className="rounded-[var(--radius-card)] border border-border bg-surface p-4">
      <p className="mb-3 text-sm font-medium text-ink">Tags</p>
      <TagInput
        id={`${entityType}-${entityId}-tags`}
        value={tagIds ?? []}
        onChange={(next) => {
          setTags.mutate(next);
        }}
      />
    </div>
  );
}
